import React from "react";

const Callback = () => (
  <div className="container">
    <h4>Callback route: Authenticating!</h4>
  </div>
);

export default Callback;
